import { render, staticRenderFns } from "./DeliveryDateDetails.vue?vue&type=template&id=1ca59b1e"
import script from "./DeliveryDateDetails.vue?vue&type=script&lang=js"
export * from "./DeliveryDateDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports